<template>
  <div class="user-protocol-container" v-loading="loadingData">
    <div class="user-protocol-title">用户协议</div>
    <div class="user-protocol-content" v-html="protocolContent" />
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      protocolContent: "",
      loadingData: true
    };
  },
  created: function() {
    // 查询用户协议
    this.loadProtocolData();
  },
  methods: {
    async loadProtocolData() {
      const res = await httpRequest("/app/setting/protocol", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.protocolContent = res.data;
      }
      this.loadingData = false;
    }
  }
};
</script>

<style scoped lang="scss">
.user-protocol-container {
  height: calc(100vh - 67px - 8px - 100px);
  background-color: #ffffff;
  margin-top: 8px;
  .user-protocol-title {
    height: 68px;
    line-height: 68px;
    background: rgba(0, 176, 171, 1);
    border-radius: 4px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
  }
  .user-protocol-content {
    height: calc(100vh - 67px - 8px - 100px - 68px);
    overflow-y: scroll;
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
